import {
  ADD_VEHICLE_MODEL,
  ADD_VEHICLE_MODEL_ERROR,
  ADD_VEHICLE_MODEL_START,
  UPDATE_VEHICLE_MODEL,
  UPDATE_VEHICLE_MODEL_ERROR,
  UPDATE_VEHICLE_MODEL_START,
  GET_VEHICLE_MODEL,
  GET_VEHICLE_MODEL_ERROR,
  GET_VEHICLE_MODEL_LIST_PAGEABLE,
  GET_VEHICLE_MODEL_LIST_PAGEABLE_START,
  GET_VEHICLE_MODEL_LIST_PAGEABLE_ERROR,
  DELETE_VEHICLE_MODEL,
  DELETE_VEHICLE_MODEL_ERROR,
  DELETE_VEHICLE_MODEL_START,
  CLEAR_ERROR_VEHICLE_MODEL,
  GET_VEHICLE_MODEL_LIST,
  GET_VEHICLE_MODEL_LIST_ERROR,
  GET_VEHICLE_MODEL_LIST_START,
  GET_VEHICLE_MODEL_BY_BRAND_ID,
  GET_VEHICLE_MODEL_BY_BRAND_ID_START,
  GET_VEHICLE_MODEL_BY_BRAND_ID_ERROR,
} from '../actions/types';

const initialState = {
  emptyList: false,
  vehicleModelList: [],
  vehicleModel: {},
  loading: false,
  error: undefined,
  totalElements: '',
  pageNumber: -1,
  pageSize: 8,
  isLastPage: false,
};

const clearError = (state) => {
  return {
    ...state,
    error: undefined,
  };
};

const addVehicleModelStart = (state) => {
  return {
    ...state,
    loading: false,
  };
};

const addVehicleModelError = (state, action) => {
  return {
    ...state,
    error: action.payload,
    loading: false,
  };
};

const addVehicleModel = (state, action) => {
  return {
    ...state,
    loading: false,
    vehicleModelList: state.vehicleModelList.concat(action.payload),
  };
};

const updateVehicleModelStart = (state) => {
  return {
    ...state,
  };
};

const updateVehicleModelError = (state, action) => {
  return {
    ...state,
    error: action.payload,
    loading: false,
  };
};

const updateVehicleModel = (state, action) => {
  return {
    ...state,

    vehicleModelList: state.vehicleModelList.map((vehicleModel) =>
      vehicleModel.id === action.payload.id ? action.payload : vehicleModel
    ),
    loading: false,
  };
};

const findAllVehicleModelPageableStart = (state) => {
  return {
    ...state,
    loading: true,
  };
};

const findAllVehicleModelPageableError = (state, action) => {
  return {
    ...state,
    error: action.payload,
  };
};

const findAllVehicleModelPageable = (state, action) => {
  return {
    ...state,
    vehicleModelList: [...action.payload.list],
    totalElements: action.payload.totalElements,
  };
};

const deleteVehicleModelStart = (state) => {
  return {
    ...state,
    loading: true,
  };
};

const deleteVehicleModelError = (state, action) => {
  return {
    ...state,
    error: action.payload,
    loading: false,
  };
};

const deleteVehicleModel = (state, action) => {
  return {
    ...state,
    loading: false,
    vehicleModelList: state.vehicleModelList.filter(
      (vehicleModel) => vehicleModel.id !== action.payload
    ),
  };
};

const findVehicleModelByIdStart = (state) => {
  return {
    ...state,
    loading: true,
  };
};

const findVehicleModelByIdError = (state, action) => {
  return {
    ...state,
    error: action.payload,
    loading: false,
  };
};

const findVehicleModelById = (state, action) => {
  return {
    ...state,
    loading: false,
    vehicleModel: action.payload,
  };
};

const findAllVehicleModelStart = (state) => {
  return {
    ...state,
    loading: true,
  };
};

const findAllVehicleModelError = (state, action) => {
  return {
    ...state,
    error: action.payload,
    loading: false,
  };
};

const findAllVehicleModel = (state, action) => {
  return {
    ...state,
    loading: false,
    vehicleModelList: action.payload,
  };
};


const findVehicleModelByBrandIdStart = (state) => {
  return {
    ...state,
    loading: true,
  };
};

const findVehicleModelByBrandIdError = (state, action) => {
  return {
    ...state,
    error: action.payload,
    loading: false,
  };
};

const findVehicleModelByBrandId = (state, action) => {
  return {
    ...state,
    loading: false,
    vehicleModelList: action.payload,
  };
};




export default function (state = initialState, action) {
  switch (action.type) {
    case ADD_VEHICLE_MODEL:
      return addVehicleModel(state, action);
    case ADD_VEHICLE_MODEL_START:
      return addVehicleModelStart(state);
    case ADD_VEHICLE_MODEL_ERROR:
      return addVehicleModelError(state, action);

    case UPDATE_VEHICLE_MODEL:
      return updateVehicleModel(state, action);
    case UPDATE_VEHICLE_MODEL_START:
      return updateVehicleModelStart(state);
    case UPDATE_VEHICLE_MODEL_ERROR:
      return updateVehicleModelError(state, action);

    case GET_VEHICLE_MODEL:
      return findVehicleModelById(state, action);
    case GET_VEHICLE_MODEL_LIST_START:
      return findVehicleModelByIdStart(state);
    case GET_VEHICLE_MODEL_ERROR:
      return findVehicleModelByIdError(state, action);

    case GET_VEHICLE_MODEL_LIST_PAGEABLE_START:
      return findAllVehicleModelPageableStart(state, action);
    case GET_VEHICLE_MODEL_LIST_PAGEABLE:
      return findAllVehicleModelPageable(state, action);
    case GET_VEHICLE_MODEL_LIST_PAGEABLE_ERROR:
      return findAllVehicleModelPageableError(state, action);

    case DELETE_VEHICLE_MODEL:
      return deleteVehicleModel(state, action);
    case DELETE_VEHICLE_MODEL_START:
      return deleteVehicleModelStart(state);
    case DELETE_VEHICLE_MODEL_ERROR:
      return deleteVehicleModelError(state, action);
    case CLEAR_ERROR_VEHICLE_MODEL:
      return clearError(state);

    case GET_VEHICLE_MODEL_LIST:
      return findAllVehicleModel(state, action);
    case GET_VEHICLE_MODEL_LIST_START:
      return findAllVehicleModelStart(state);
    case GET_VEHICLE_MODEL_LIST_ERROR:
      return findAllVehicleModelError(state, action);

       case GET_VEHICLE_MODEL_BY_BRAND_ID:
      return findVehicleModelByBrandId(state, action);
    case  GET_VEHICLE_MODEL_BY_BRAND_ID_START:
      return findVehicleModelByBrandIdStart(state);
    case GET_VEHICLE_MODEL_BY_BRAND_ID_ERROR:
      return findVehicleModelByBrandIdError(state, action);

    default:
      return state;
  }
}
